import type { Widget } from '@/types/widgets';
import slaydApi from './axiosInstance';

export interface PageFetchResponse {
  widgets: Widget[];
}

export const fetchHomePage = async (): Promise<PageFetchResponse> => {
  try {
    const response =
      await slaydApi.get<PageFetchResponse>('/homepage/widgets/');

    if (
      !response.data ||
      !response.data.widgets ||
      !response.data.widgets.length
    )
      throw new Error('Invalid response');

    return response.data;
  } catch (error) {
    console.error(error);
    throw new Error(`Error fetching product data`);
  }
};
